import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";

const BG =
  "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=2200&q=80";

export default function ExpertiseSection() {
  const { t } = useI18n();
  const topics = t("expertise.topics");

  return (
    <section
      data-testid={TID.expertise}
      className="relative bg-[color:var(--gc-ink)] text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-25">
        <img
          src={BG}
          alt=""
          className="w-full h-full object-cover gc-kenburns"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[color:var(--gc-ink)] via-[color:var(--gc-ink)]/95 to-[color:var(--gc-ink)]/70" />
      <div className="absolute inset-0 gc-grid-bg-dark opacity-50" />

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6"
          >
            <p className="gc-eyebrow text-white/60">{t("expertise.eyebrow")}</p>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.02] tracking-tight font-[700]">
              {t("expertise.title")}
            </h2>
            <p className="mt-8 text-lg leading-relaxed text-white/80 max-w-xl">
              {t("expertise.lead")}
            </p>
            <p className="mt-4 text-base leading-relaxed text-white/65 max-w-xl">
              {t("expertise.lead2")}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="lg:col-span-6 lg:pl-10"
          >
            <ul className="border-t border-white/10">
              {Array.isArray(topics) &&
                topics.map((tp, i) => (
                  <li
                    key={i}
                    className="flex items-center justify-between py-4 border-b border-white/10 group hover:bg-white/[0.03] transition-colors px-2 -mx-2"
                  >
                    <div className="flex items-center gap-4">
                      <span className="font-mono text-[11px] tracking-[0.18em] text-white/40 w-8">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="text-[15px] md:text-base font-medium text-white/90 group-hover:text-white">
                        {tp}
                      </span>
                    </div>
                    <span className="w-3 h-3 border border-white/30 group-hover:bg-[color:var(--gc-red)] group-hover:border-[color:var(--gc-red)] transition-colors" />
                  </li>
                ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
